import { skipToken, useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the live Stripe subscription status for a patient. */
export function useGetPatientSubscription(patientId: string | undefined) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient', patientId, 'subscription'],
    queryFn:
      patientId === undefined
        ? skipToken
        : async () => {
            const response = await api.get('/patients/:patientId/subscription', {
              params: { patientId },
            })
            if (!response.success) throw new Error(response.error.message)
            return response.data
          },
    staleTime: 60_000,
  })
}
